import get from 'lodash/get';

const SET_DEBUG_STRING = 'DEBUG/SET_STRING';

export const getDebugString = state => get(state, `${debugReducerKey}.debugString`);
export const setDebugString = string => ({
  type: SET_DEBUG_STRING,
  payload: string
});

const initialState = {
  debugString: null
};

export const debugReducerKey = 'debugData';
export const debugReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEBUG_STRING:
      const debugString = action.payload;
      return { ...state, debugString };

    default:
      return state;
  }
};
